export const daoTokensMock = {
  "daoTokens": [
      {
          "tokenName": "MNT",
          "tokenSymbol": "MNT",
          "daosTotalBalance": 3334936458.1555285,
          "daosTotalUsdValue": 5074714156.001293,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MNT.webp",
          "numDaos": 9
      },
      {
          "tokenName": "UNI",
          "tokenSymbol": "UNI",
          "daosTotalBalance": 383429591.5638767,
          "daosTotalUsdValue": 3355569841.786335,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UNI.webp",
          "numDaos": 38
      },
      {
          "tokenName": "ETH",
          "tokenSymbol": "ETH",
          "daosTotalBalance": 395844.0324367102,
          "daosTotalUsdValue": 1627074847.6872885,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "numDaos": 373
      },
      {
          "tokenName": "OP",
          "tokenSymbol": "OP",
          "daosTotalBalance": 1906686975.6309843,
          "daosTotalUsdValue": 1411764806.2165818,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/optimism-token.png",
          "numDaos": 48
      },
      {
          "tokenName": "ENS",
          "tokenSymbol": "ENS",
          "daosTotalBalance": 63102815.63836961,
          "daosTotalUsdValue": 1394567389.7989352,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ENS.webp",
          "numDaos": 24
      },
      {
          "tokenName": "ARB",
          "tokenSymbol": "ARB",
          "daosTotalBalance": 2989472819.8551407,
          "daosTotalUsdValue": 1388608850.6187704,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ARB.webp",
          "numDaos": 30
      },
      {
          "tokenName": "MORPHO",
          "tokenSymbol": "MORPHO",
          "daosTotalBalance": 676480952.6769127,
          "daosTotalUsdValue": 1272128703.967682,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MORPHO.webp",
          "numDaos": 3
      },
      {
          "tokenName": "DEXE",
          "tokenSymbol": "DEXE",
          "daosTotalBalance": 86027626.08505318,
          "daosTotalUsdValue": 961900368.354622,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DEXE.webp",
          "numDaos": 1
      },
      {
          "tokenName": "POL",
          "tokenSymbol": "POL",
          "daosTotalBalance": 3573195910.467039,
          "daosTotalUsdValue": 846578741.1582015,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/POL.webp",
          "numDaos": 127
      },
      {
          "tokenName": "GNO",
          "tokenSymbol": "GNO",
          "daosTotalBalance": 5159221.331304344,
          "daosTotalUsdValue": 732775157.0733796,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GNO.webp",
          "numDaos": 17
      },
      {
          "tokenName": "GRT",
          "tokenSymbol": "GRT",
          "daosTotalBalance": 6309272476.1411915,
          "daosTotalUsdValue": 567113264.1662253,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GRT.webp",
          "numDaos": 30
      },
      {
          "tokenName": "RSC",
          "tokenSymbol": "RSC",
          "daosTotalBalance": 792115528.36074,
          "daosTotalUsdValue": 439002546.8781134,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RSC.webp",
          "numDaos": 3
      },
      {
          "tokenName": "SPK",
          "tokenSymbol": "SPK",
          "daosTotalBalance": 6130748607.819695,
          "daosTotalUsdValue": 339674082.26762444,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SPK.webp",
          "numDaos": 6
      },
      {
          "tokenName": "TRIBE",
          "tokenSymbol": "TRIBE",
          "daosTotalBalance": 530461704.75773835,
          "daosTotalUsdValue": 324355471.80647796,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TRIBE.webp",
          "numDaos": 5
      },
      {
          "tokenName": "USDS",
          "tokenSymbol": "USDS",
          "daosTotalBalance": 228649113.99883074,
          "daosTotalUsdValue": 228580557.08722863,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDS.webp",
          "numDaos": 7
      },
      {
          "tokenName": "SUPER",
          "tokenSymbol": "SUPER",
          "daosTotalBalance": 384366637.93836313,
          "daosTotalUsdValue": 216662443.44253305,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SUPER.webp",
          "numDaos": 4
      },
      {
          "tokenName": "USDC",
          "tokenSymbol": "USDC",
          "daosTotalBalance": 223487916.02502966,
          "daosTotalUsdValue": 204154615.44050974,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "numDaos": 271
      },
      {
          "tokenName": "EIGEN",
          "tokenSymbol": "EIGEN",
          "daosTotalBalance": 104773767.09602721,
          "daosTotalUsdValue": 177173467.43728855,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/EIGEN.webp",
          "numDaos": 8
      },
      {
          "tokenName": "BIT",
          "tokenSymbol": "BIT",
          "daosTotalBalance": 105469826.25957048,
          "daosTotalUsdValue": 159742704.04260594,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BIT.webp",
          "numDaos": 2
      },
      {
          "tokenName": "BUIDL",
          "tokenSymbol": "BUIDL",
          "daosTotalBalance": 142251086.47,
          "daosTotalUsdValue": 142251086.47,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BUIDL.webp",
          "numDaos": 1
      },
      {
          "tokenName": "COW",
          "tokenSymbol": "COW",
          "daosTotalBalance": 438844051.9649242,
          "daosTotalUsdValue": 137785863.33802378,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VCOW.webp",
          "numDaos": 7
      },
      {
          "tokenName": "SCR",
          "tokenSymbol": "SCR",
          "daosTotalBalance": 441317042.5528339,
          "daosTotalUsdValue": 135484332.0672092,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SCR.webp",
          "numDaos": 3
      },
      {
          "tokenName": "AAVE",
          "tokenSymbol": "AAVE",
          "daosTotalBalance": 464744.37235647015,
          "daosTotalUsdValue": 133559463.36918417,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AAVE.webp",
          "numDaos": 25
      },
      {
          "tokenName": "LDO",
          "tokenSymbol": "LDO",
          "daosTotalBalance": 104514275.17111929,
          "daosTotalUsdValue": 125732241.13538522,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LDO.webp",
          "numDaos": 17
      },
      {
          "tokenName": "SAND",
          "tokenSymbol": "SAND",
          "daosTotalBalance": 441045383.47071695,
          "daosTotalUsdValue": 124576653.53041285,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SAND.webp",
          "numDaos": 4
      },
      {
          "tokenName": "RBN",
          "tokenSymbol": "RBN",
          "daosTotalBalance": 929985999.01551,
          "daosTotalUsdValue": 124389112.88827975,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RBN.webp",
          "numDaos": 1
      },
      {
          "tokenName": "FLUID",
          "tokenSymbol": "FLUID",
          "daosTotalBalance": 23246899.126442056,
          "daosTotalUsdValue": 124039922.67963405,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/INST.webp",
          "numDaos": 5
      },
      {
          "tokenName": "miMATIC",
          "tokenSymbol": "miMATIC",
          "daosTotalBalance": 121148627.12278861,
          "daosTotalUsdValue": 117264062.6748343,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MIMATIC.webp",
          "numDaos": 10
      },
      {
          "tokenName": "BEAM",
          "tokenSymbol": "BEAM",
          "daosTotalBalance": 6672685372.23104,
          "daosTotalUsdValue": 114159459.37696289,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BEAM.webp",
          "numDaos": 2
      },
      {
          "tokenName": "HFT",
          "tokenSymbol": "HFT",
          "daosTotalBalance": 1655942022.3067467,
          "daosTotalUsdValue": 114014161.6028286,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/HFT.webp",
          "numDaos": 3
      },
      {
          "tokenName": "OHM",
          "tokenSymbol": "OHM",
          "daosTotalBalance": 4910547.462445384,
          "daosTotalUsdValue": 110141971.79277709,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VOTE.webp",
          "numDaos": 5
      },
      {
          "tokenName": "ID",
          "tokenSymbol": "ID",
          "daosTotalBalance": 647159985.4467803,
          "daosTotalUsdValue": 106947334.3837252,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ID.webp",
          "numDaos": 3
      },
      {
          "tokenName": "AMP",
          "tokenSymbol": "AMP",
          "daosTotalBalance": 30853483146.9359,
          "daosTotalUsdValue": 100993693.13509127,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AMP.webp",
          "numDaos": 4
      },
      {
          "tokenName": "MANA",
          "tokenSymbol": "MANA",
          "daosTotalBalance": 296341619.9323206,
          "daosTotalUsdValue": 90379761.27616343,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VP.webp",
          "numDaos": 12
      },
      {
          "tokenName": "DOT",
          "tokenSymbol": "DOT",
          "daosTotalBalance": 21888259.411791332,
          "daosTotalUsdValue": 88844980.85375138,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DOT.webp",
          "numDaos": 4
      },
      {
          "tokenName": "UMA",
          "tokenSymbol": "UMA",
          "daosTotalBalance": 68947431.85719198,
          "daosTotalUsdValue": 85782218.74804996,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UMA.webp",
          "numDaos": 8
      },
      {
          "tokenName": "SURE",
          "tokenSymbol": "SURE",
          "daosTotalBalance": 61272706560.592865,
          "daosTotalUsdValue": 74936411.76551637,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SURE.webp",
          "numDaos": 2
      },
      {
          "tokenName": "MAV",
          "tokenSymbol": "MAV",
          "daosTotalBalance": 984147670.1888202,
          "daosTotalUsdValue": 67108209.92262895,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MAV.webp",
          "numDaos": 5
      },
      {
          "tokenName": "DYDX",
          "tokenSymbol": "DYDX",
          "daosTotalBalance": 99985354.79871559,
          "daosTotalUsdValue": 66165122.91064335,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DYDX.webp",
          "numDaos": 2
      },
      {
          "tokenName": "ORBS",
          "tokenSymbol": "ORBS",
          "daosTotalBalance": 3711702081.6629014,
          "daosTotalUsdValue": 65856822.729919456,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ORBS.webp",
          "numDaos": 3
      },
      {
          "tokenName": "SAFE",
          "tokenSymbol": "SAFE",
          "daosTotalBalance": 154952351.82473347,
          "daosTotalUsdValue": 62985343.19267958,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SAFE.webp",
          "numDaos": 118
      },
      {
          "tokenName": "HAIR",
          "tokenSymbol": "HAIR",
          "daosTotalBalance": 838621.2003739984,
          "daosTotalUsdValue": 59477345.03753649,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/HAIR.webp",
          "numDaos": 8
      },
      {
          "tokenName": "EUL",
          "tokenSymbol": "EUL",
          "daosTotalBalance": 6096661.1247970695,
          "daosTotalUsdValue": 58448690.203429505,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/EUL.webp",
          "numDaos": 1
      },
      {
          "tokenName": "TORN",
          "tokenSymbol": "TORN",
          "daosTotalBalance": 4229333.669044376,
          "daosTotalUsdValue": 56091819.271905996,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TORN.webp",
          "numDaos": 6
      },
      {
          "tokenName": "DCB",
          "tokenSymbol": "DCB",
          "daosTotalBalance": 611334379.9845119,
          "daosTotalUsdValue": 54843718.70142186,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DCB.webp",
          "numDaos": 1
      },
      {
          "tokenName": "YGG",
          "tokenSymbol": "YGG",
          "daosTotalBalance": 312258124.57009107,
          "daosTotalUsdValue": 53663809.13143707,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/YGG.webp",
          "numDaos": 4
      },
      {
          "tokenName": "ACX",
          "tokenSymbol": "ACX",
          "daosTotalBalance": 422874086.7324517,
          "daosTotalUsdValue": 51473744.513340525,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ACX.webp",
          "numDaos": 2
      },
      {
          "tokenName": "ANVL",
          "tokenSymbol": "ANVL",
          "daosTotalBalance": 51726034904.243805,
          "daosTotalUsdValue": 50198975.94398027,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ANVL.webp",
          "numDaos": 1
      },
      {
          "tokenName": "WLFI",
          "tokenSymbol": "WLFI",
          "daosTotalBalance": 200001502.73381668,
          "daosTotalUsdValue": 47020001.2383183,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WLFI.webp",
          "numDaos": 9
      },
      {
          "tokenName": "PHA",
          "tokenSymbol": "PHA",
          "daosTotalBalance": 436289883.3812623,
          "daosTotalUsdValue": 46988420.43456376,
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PHA.webp",
          "numDaos": 3
      }
  ],
  // "currentPage": null,
  // "isEndOfDaoTokensList": false
}